import { createContext, useContext } from "react";

// The current RWC island's own shadow root.
const IslandPortalContainerContext = createContext<ShadowRoot | undefined>(
  undefined,
);

export const IslandPortalContainerProvider =
  IslandPortalContainerContext.Provider;

export function useIslandPortalContainer(): ShadowRoot | undefined {
  return useContext(IslandPortalContainerContext);
}

// This island's own host element (e.g. for ElementInternals lookups).
export function useIslandHost(): HTMLElement | undefined {
  return useIslandPortalContainer()?.host as HTMLElement | undefined;
}

// The single portal root shared by every island.
const FloatingPortalContainerContext = createContext<ShadowRoot | undefined>(
  undefined,
);

export const FloatingPortalContainerProvider =
  FloatingPortalContainerContext.Provider;

export function useFloatingPortalContainer(): ShadowRoot | undefined {
  return useContext(FloatingPortalContainerContext);
}
